import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getAllParticipantsOfAssessment } from "../services/authService";
import { encodeId } from '../utills/idUtils';
const AssessmentList = ({ assessments, onStartNewAssessment }) => {
    const [filter, setFilter] = useState('all');
    const [participantsData, setParticipantsData] = useState({});
    const navigate = useNavigate();
    const { state } = useAuth();
    const { user } = state;
    let getUserDetails = user;

    const fetchParticipantsData = async (assessmentId) => {
        try {
            const fetchAllAssmentUser = await getAllParticipantsOfAssessment(assessmentId);
            const participants = fetchAllAssmentUser.data;
            const completedCount = participants.filter(participant => participant.status === 'Completed').length;
            const totalParticipants = participants.length;

            setParticipantsData(prevState => ({
                ...prevState,
                [assessmentId]: {
                    completedCount,
                    totalParticipants
                }
            }));
        } catch (error) {
            console.error("Error fetching participants:", error);
        }
    };

    useEffect(() => {
        assessments.forEach(assessment => {
            fetchParticipantsData(assessment.assessment_id);
        });
    }, [assessments]);

    const filteredAssessments = assessments.filter(assessment => {
        if (filter === 'self') return assessment.assessment_type === 'self';
        if (filter === '360') return assessment.assessment_type === '360';
        return true;
    }).reverse();

    return (
        <div className="p-4">
            <div className="mb-4 flex flex-wrap justify-start">
                <button
                    onClick={() => setFilter('all')}
                    className={`mr-2 mb-2 lg:mb-0 px-4 py-2 rounded ${filter === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
                >
                    All
                </button>
                <button
                    onClick={() => setFilter('self')}
                    className={`mr-2 mb-2 lg:mb-0 px-4 py-2 rounded ${filter === 'self' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
                >
                    Self Assessments
                </button>
                <button
                    onClick={() => setFilter('360')}
                    className={`mb-2 lg:mb-0 px-4 py-2 rounded ${filter === '360' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
                >
                    360 Assessments
                </button>
            </div>

            {filteredAssessments.length === 0 ? (
                <>              <h2 className="text-gray-700 mb-4 text-xl">Assessments that I initiated </h2>
                    <div className="flex items-center justify-center min-h-32 max-h-96">

                        <p className="text-gray-500 text-xl font-semibold">No assessments found.</p>
                    </div></>
            ) : (
                <>
                    <h2  style={{ fontFamily: "Helvetica" }} className="text-gray-700 mb-4 text-xl">Assessments that I initiated </h2>
                    <div className="space-y-4 overflow-y-auto min-h-[74vh] lg:min-h-32 max-h-96">
                        {filteredAssessments.map((assessment) => (
                            <div key={assessment.assessment_id} className="flex flex-col md:flex-row items-center md:items-start bg-blue-100 p-4 rounded-lg">
                                <div className="w-12 h-12 bg-blue-500 text-white flex items-center justify-center rounded lg:mb-4 mb-1 md:mb-0 md:mr-4">
                                    {`${getUserDetails?.first_name?.slice(0, 1)}${getUserDetails?.last_name?.slice(0, 1)}`}
                                </div>
                                <div className="flex-1 text-center md:text-left lg:mb-4 mb-2 md:mb-0">
                                </div>
                                <div className="flex-1 text-center md:text-left lg:mb-4 mb-2 md:mb-0">
                                    <h3 style={{ fontFamily: "Helvetica", fontSize:"20px" }}className="font-bold">{`Initiated for ${assessment.assessment_type === '360' ? 'Group' : 'self'}`}</h3>
                                    <p className="text-gray-500">on {new Date(assessment.initiation_date).toLocaleDateString()}</p>
                                    {assessment.assessment_type === '360' && (
                                        participantsData[assessment.assessment_id] && (
                                            <p className='text-gray-500 text-sm'>
                                                {Math.max(participantsData[assessment.assessment_id].completedCount, 0)} / {Math.max(participantsData[assessment.assessment_id].totalParticipants, 0)} Completed
                                            </p>
                                        )
                                    )}


                                </div>
                                <div className="flex-1 text-center md:text-left lg:mb-4 mb-2 md:mb-0">
                                    <h3 className="font-bold">
                                        {assessment.assessment_type === '360' && assessment.current_status === 'Pending' && (
                                            <> <span style={{ fontFamily: "Helvetica", fontSize:"20px" }} className="ml-2 text-yellow-500 font-semibold">Pending</span>
                                                <p  style={{ fontFamily: "Helvetica", fontSize:"15px" }} className="ml-2 text-sm text-gray-500">not invited yet </p>
                                            </>
                                        )}
                                        {assessment.assessment_type === '360' && assessment.current_status === 'Started' && (
                                            <span style={{ fontFamily: "Helvetica", fontSize:"20px" }}  className="ml-2 text-green-500 font-semibold">Started</span>
                                        )}
                                        {(assessment.assessment_type === '360' || assessment.assessment_type === 'self') && assessment.current_status === 'Completed' && (
                                            <span  style={{ fontFamily: "Helvetica", fontSize:"20px" }} className="ml-2 text-green-500 font-semibold">Completed</span>
                                        )}
                                    </h3>
                                </div>
                                <div className="flex-1 text-center md:text-left">
                                    {(assessment.assessment_type === 'self' || assessment.assessment_type === '360') && assessment.current_status === 'Completed' ? (
                                        <button
                                            onClick={() => setTimeout(() => {
                                                // const encodedId = encodeId(assessment.assessment_id); // Encode the assessment ID
                                                const encodedId = encodeId(assessment.assessment_id); // Encode the assessment ID

                                                navigate(`/report/${encodedId}`);
                                            }, 1000)}
                                            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                                        >
                                            See Report
                                        </button>
                                    ) : assessment.assessment_type === '360' && assessment.current_status === 'Started' ? (
                                        <button
                                            onClick={() => setTimeout(() => {
                                                const encodedId = encodeId(assessment.assessment_id); // Encode the assessment ID

                                                navigate(`/participant-details/${encodedId}`);
                                            }, 1000)}
                                            className="bg-blue-600 text-white px-4 py-2 rounded"
                                        >
                                            See Details
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                onStartNewAssessment(assessment.assessment_id);
                                            }}
                                            className="bg-blue-600 text-white px-4 py-2 rounded"
                                        >
                                            {assessment.assessment_type === 'self' ? 'Continue Assessment' : 'Continue Invitations'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default AssessmentList;
